import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';

@Injectable({
  providedIn: 'root'
})
export class GetConfigContractService {

  constructor() {
  }

  getConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigFilter(),
        this.getConfigContractDisplayName(),
        this.getConfigContractInvoicing(),
        this.getConfigContractProductID(),
        this.getConfigContractIsIndex(),
        this.getConfigContractCustomInvoice(),
        this.getConfigContractTriggerStart(),
        this.getConfigContractRetractationDelay(),
        this.getConfigContractRecurrence(),
        this.getConfigContractSplit(),
        this.getConfigContractSla(),
        this.getConfigContractCurrency(),
        this.getConfigContractInfo(),
        this.getConfigRuleBilling(),
        this.getConfigRuleFee(),
        this.getConfigRulePrice(),
        this.getConfigRuleLicense(),
        this.getConfigRulePriceConnection(),
        this.getConfigContractSetting(),

      ]
    }
  }
  getMiscellaneousConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.information(),
        this.getConfigComments()
      ]
    }
  }
  information(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'Created',
          controlName: ['created'],
          placeholder: 'created',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['createdBy', 'created'],
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'CreatedBy',
          controlName: ['createdBy'],
          placeholder: 'createdBy',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'Updated',
          controlName: ['updated'],
          placeholder: 'updated',
          presentation: 'edit',
          options: {
            show: false,
            shortInput: true,
            concatenate: ['updatedBy', 'updated'],
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'UpdatedBy',
          controlName: ['updatedBy'],
          placeholder: 'updatedBy',
          presentation: 'edit',
          options: {
            show: false,
            labelShowInDetail: false
          }
        }
      ]
    }
  }
  getConfigComments(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: '',
          controlName: ['commentsBlog'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'textarea',
          label: '',
          controlName: ['comments'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        }
      ]
    }
  }

  getConfigFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startDate'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PRICE',
          controlName: ['price'],
          placeholder: 'GENERIC_PRICE',
          presentation: 'filter',
          options: {
            show: true,
            inputType: {
              type: 'number',
              step: 0.1
            }
          }
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'products',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['endDate'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'CONTRACT_PURCHASE_ORDER',
          controlName: ['po'],
          placeholder: 'CONTRACT_PURCHASE_ORDER',
          presentation: 'filter',
          options: {
            show: true
          }
        }
      ]
    }
  }

  getConfigContractInvoicing(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'CONTRACT_FORM_START',
          controlName: ['start'],
          placeholder: 'CONTRACT_FORM_START',
          error: 'ORDER_FORM_SITE_EXPEDITION_DATE_ERROR',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'edit'
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_FORM_END',
          controlName: ['end'],
          placeholder: 'CONTRACT_FORM_END',
          error: 'ORDER_FORM_SITE_EXPEDITION_DATE_ERROR',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              daysOfWeekDisable: false,
              defaultDate: null,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: true,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom',
              }
            }
          },
          presentation: 'edit'
        }
      ]
    }
  }

  getConfigContractIsIndex(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'Active',
          controlName: ['isIndex'],
          placeholder: 'CONTRACT_FORM_IS_INDEX',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left'
          }
        },
      ]
    }
  }
  getConfigContractSetting(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'CONTRACT_FORM_PO_REQUIRED_TITLE',
          controlName: ['isPORequired'],
          placeholder: 'CONTRACT_FORM_PO_REQUIRED_TITLE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left',
            labelSize: 1
          }
        },
        {
          type: 'checkBox',
          label: 'CONTRACT_FORM_INDEXATION_OF_CONTRACT',
          controlName: ['isIndex'],
          placeholder: 'CONTRACT_FORM_INDEXATION_OF_CONTRACT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left',
            labelSize: 1
          }
        },
        {
          type: 'checkBox',
          label: 'CONTRACT_FORM_PERIODIC_ADJUSTMENT_OF_CONTRACT',
          controlName: ['isPeriodicAdjustment'],
          placeholder: 'CONTRACT_FORM_PERIODIC_ADJUSTMENT_OF_CONTRACT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left',
            labelSize: 1,
            description: 'Monthly invoice new player until start period'
          }
        },
      ]
    }
  }

  getConfigContractRecurrence(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_RECURRENCE',
          controlName: ['recurrence', 'id'],
          placeholder: 'CONTRACT_FORM_RECURRENCE',
          data: 'recurrence',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
        // {
        //   type: 'checkBox',
        //   label: 'CONTRACT_FORM_RECURRENCE_SHIFT_MONTH_ALLOW',
        //   controlName: [ 'allowShiftMonth'],
        //   placeholder: 'CONTRACT_FORM_RECURRENCE_SHIFT_MONTH_ALLOW',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: false,
        //     labelPosition: 'left',
        //     labelSize: 11
        //   }
        // },
        // {
        //   type: 'select',
        //   label: 'CONTRACT_FORM_RECURRENCE_SHIFT_MONTH',
        //   controlName: ['BillingShiftMonth' , 'id'],
        //   placeholder: 'CONTRACT_FORM_RECURRENCE_SHIFT_MONTH',
        //   data: 'month',
        //   options: {
        //     show: true,
        //     value: 'id',
        //     vue: 'name',
        //     labelShowInDetail: false,
        //     toggle: false
        //   },
        //   presentation: 'edit'
        // }
      ]
    }
  }
  getConfigContractShift(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'GENERIC_STARTING_DATE',
          controlName: ['BillingShift'],
          placeholder: 'GENERIC_STARTING_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              disabledDates: [
                '2024-02-29',
                '2028-02-29',
                '2032-02-29',
                '2036-02-29',
                '2040-02-29',
                '2044-02-29',
                '2048-02-29',
                '2052-02-29',
                '2056-02-29',
                '2060-02-29',
                '2064-02-29',
                '2068-02-29',
                '2072-02-29',
                '2076-02-29',
                '2080-02-29',
                '2084-02-29',
                '2088-02-29',
                '2092-02-29',
                '2096-02-29',
              ],
              minDate: false,
              numberDelayDays: 0,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigContractSplit(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_SPLIT',
          controlName: ['split', 'id'],
          placeholder: 'CONTRACT_FORM_SPLIT',
          data: 'split',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        }
      ]
    }
  }

  getConfigContractProductID(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_PRODUCT_ID',
          controlName: ['productID', 'id'],
          placeholder: 'CONTRACT_FORM_PRODUCT_ID',
          data: 'product',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigContractSla(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_SLA',
          controlName: ['sla', 'id'],
          placeholder: 'CONTRACT_FORM_CURRENCY',
          data: 'sla',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
      ]
    }
  }

  getConfigContractCustomInvoice(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_CUSTOM_INVOICE',
          controlName: ['customInvoice'],
          placeholder: 'CONTRACT_FORM_CUSTOM_INVOICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false
          }
        }
      ]
    }
  }

  getConfigContractRetractationDelay(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_RETRACTATION',
          controlName: ['retractationDelay'],
          placeholder: 'CONTRACT_FORM_RETRACTATION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            unit: 'CONTRACT_FORM_RETRACTATION_UNITE',
            shortInput: true,
            inputType: {
              type: 'number',
              step: 1
            }
          }
        },
        // {
        //   type: 'input',
        //   label: 'CONTRACT_FORM_PAYMENT',
        //   controlName: ['paymentDelay'],
        //   placeholder: 'CONTRACT_FORM_PAYMENT',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     unit: 'CONTRACT_FORM_PAYMENT_UNITE',
        //     shortInput: true,
        //     inputType: {
        //       type: 'number',
        //       step: 1
        //     }
        //   }
        // }
      ]
    }
  }

  getConfigContractCurrency(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_CURRENCY',
          controlName: ['currency', 'id'],
          placeholder: 'CONTRACT_FORM_CURRENCY',
          data: 'currenciesList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'detail'
        },
      ]
    }
  }

  getConfigContractTriggerStart(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_TRIGGER_START',
          controlName: ['triggerStart', 'id'],
          placeholder: 'CONTRACT_FORM_TRIGGER_START',
          data: 'TriggerStart',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false,
          },
          presentation: 'edit'
        }
      ]
    }
  }

  getConfigContractDisplayName(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_SUFFIX_LABEL',
          controlName: ['displayName'],
          placeholder: 'GENERIC_NAME_SUFFIX_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            inputExtraLabels : '',
            longInput : true,
          }
        }
      ]
    }
  }

  getConfigContractInfo(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_SPLIT',
          controlName: ['split'],
          placeholder: 'ORDER_FORM_SPLIT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_ADDRESS_PRODUCTID',
          controlName: ['productID'],
          placeholder: 'ORDER_FORM_ADDRESS_PRODUCTID',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_UPDATED_LABEL',
          controlName: ['updated'],
          placeholder: 'GENERIC_UPDATED_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_UPDATED_BY_LABEL',
          controlName: ['updatedBy'],
          placeholder: 'GENERIC_UPDATED_BY_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        }
      ]
    }
  }
  getConfigNewRules(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['start'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {

              minDate: false,
              useCurrent: false,
              daysOfWeekDisable: false,
              defaultDate: null,
            }
          },
          presentation: 'edit'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['end'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              daysOfWeekDisable: false,
              defaultDate: null,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: true,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
          presentation: 'edit'
        },
      ]
    }
  }
  getConfigRuleBilling(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          controlName: ['po'],
          placeholder: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'CONTRACT_FORM_RULES_BILLING_PRODUCT',
          controlName: ['billingProduct', 'id'],
          placeholder: 'CONTRACT_FORM_RULES_BILLING_PRODUCT',
          data: 'billingproduct',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    };
  }
  getConfigRuleBillingSimple(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_RULES_BILLING_PRODUCT',
          controlName: ['billingProduct', 'id'],
          placeholder: 'CONTRACT_FORM_RULES_BILLING_PRODUCT',
          data: 'billingproduct',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    };
  }
  getConfigRuleFee(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_SETUP_FEE',
          controlName: ['setupFee'],
          placeholder: 'CONTRACT_FORM_RULES_SETUP_FEE',
          presentation: 'edit',
          options: {
            show: true,
            unit: 'CONTRACT_FORM_RULES_FEE_ONCE_OFF',
            labelShowInDetail: true,
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_COMMUNICATION_FEE',
          controlName: ['communicationFee'],
          placeholder: 'CONTRACT_FORM_RULES_COMMUNICATION_FEE',
          presentation: 'edit',
          options: {
            show: true,
            unit: 'CONTRACT_FORM_RULES_FEE_MONTHLY',
            labelShowInDetail: true,
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_MAINTENANCE_FEE',
          controlName: ['maintenanceFee'],
          placeholder: 'CONTRACT_FORM_RULES_MAINTENANCE_FEE',
          presentation: 'edit',
          options: {
            show: true,
            unit: 'CONTRACT_FORM_RULES_FEE_MONTHLY',
            labelShowInDetail: true,
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_ADMIN_FEE',
          controlName: ['adminFee'],
          placeholder: 'CONTRACT_FORM_RULES_ADMIN_FEE',
          presentation: 'edit',
          options: {
            show: true,
            unit: 'CONTRACT_FORM_RULES_FEE_BY_INVOICE',
            labelShowInDetail: true,
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_ADMIN_FEE_PERCENT',
          controlName: ['adminFeePercent'],
          placeholder: 'CONTRACT_FORM_RULES_ADMIN_FEE_PERCENT',
          presentation: 'edit',
          options: {
            show: true,
            unit: 'CONTRACT_FORM_RULES_FEE_BY_INVOICE',
            labelShowInDetail: true,
            shortInput: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'CONTRACT_FORM_RULES_MUSIC_SERVICE_FEE',
        //   controlName: ['musicService'],
        //   placeholder: 'CONTRACT_FORM_RULES_MUSIC_SERVICE_FEE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     unit: 'select',
        //     labelShowInDetail: true,
        //     shortInput: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'CONTRACT_FORM_RULES_PROJECT_MANAGER_FEE',
        //   controlName: ['projectManagement'],
        //   placeholder: 'CONTRACT_FORM_RULES_PROJECT_MANAGER_FEE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     unit: 'select',
        //     labelShowInDetail: true,
        //     shortInput: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'CONTRACT_FORM_RULES_SOFTWARE_SERVICE_FEE',
        //   controlName: ['softwareService'],
        //   placeholder: 'CONTRACT_FORM_RULES_SOFTWARE_SERVICE_FEE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     unit: 'select',
        //     labelShowInDetail: true,
        //     shortInput: true
        //   }
        // },
      ]
    };
  }
  getConfigRulePrice(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PRICE',
          controlName: ['priceFixed'],
          placeholder: 'CONTRACT_FORM_RULES_PRICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            shortInput: true
          }
        }
      ]
    }
  }
  getConfigRuleLicense(): GroupConfig {
    return {
      'config': [
        {
          type: 'select',
          label: 'CONTRACT_FORM_RULES_LICENSE',
          controlName: ['license', 'id'],
          placeholder: 'CONTRACT_FORM_RULES_LICENSE',
          data: 'Licences',
          options: {
            value: 'id',
            vue: 'name',
            show: true,
            labelShowInDetail: true,
          },
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PURCHASE_PRICE',
          controlName: ['licenseValue'],
          placeholder: 'CONTRACT_FORM_RULES_PURCHASE_PRICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            shortInput: true
          }
        }
      ]
    }
  }
  getConfigRulePriceConnection(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_ON',
          controlName: ['priceConnectionOn'],
          placeholder: 'CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            shortInput: true
          }
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_OFF',
          controlName: ['priceConnectionOff'],
          placeholder: 'CONTRACT_FORM_PRICE_EVOLUTION_CONNECTION_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            shortInput: true
          }
        },
      ]
    }
  }
  getSubscriptionFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSiteFilter()
      ]
    }
  }
  getConfigSiteFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_SUBSCRIPTION_NAME',
          controlName: ['subscriptionName'],
          placeholder: 'GENERIC_SUBSCRIPTION_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CLIENT',
          controlName: ['clientName'],
          placeholder: 'GENERIC_CLIENT',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'GENERIC_CONTRACT_NAME',
        //   controlName: ['contractName'],
        //   placeholder: 'GENERIC_CONTRACT_NAME',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        {
          type: 'input',
          label: 'GENERIC_COMPANY_NAME',
          controlName: ['companyName'],
          placeholder: 'GENERIC_COMPANY_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startBillingRangeStart' , 'startBillingRangeEnd'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['endBillingRangeStart' , 'endBillingRangeEnd'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_DELIVERY_DATE',
          controlName: ['deliveryDateRangeStart' , 'deliveryDateRangeEnd'],
          placeholder: 'ORDERS_LIST_DELIVERY_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'productsCompleteList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PRICE',
          controlName: ['price'],
          placeholder: 'GENERIC_PRICE',
          presentation: 'filter',
          options: {
            show: true,
            inputType: {
              type: 'number',
              step: 0.1
            }
          }
        },
      ]
    }
  }

}
